import Syncable from '@/syncing/Syncable.js'
import { useDisplayModeStore } from '@/store/displayMode.ts'
import { isInstanceNotStalePrecondition, isLoggedInPrecondition, isOnlinePrecondition } from '@/syncing/SyncablePreconditions.js'

class DisplayModeSyncable extends Syncable {
  constructor(globalUniqueIdentifier) {
    super(globalUniqueIdentifier, 1000 * 60 * 5, [isOnlinePrecondition, isLoggedInPrecondition, isInstanceNotStalePrecondition])
  }

  hasInitialData() {
    const currentValue = useDisplayModeStore().getDisplayMode(this.globalUniqueIdentifier)
    return currentValue !== undefined && currentValue !== null
  }

  async workload() {
    await useDisplayModeStore().loadDisplayMode(this.globalUniqueIdentifier)
  }
  static getSyncableHandle() {
    return 'displayMode'
  }
}

export default DisplayModeSyncable
